import {Show} from 'platform/foundation';

import {forwardRef, ForwardRefRenderFunction, MouseEvent} from 'react';
import {Link} from 'react-router-dom';

import {isNil} from 'ramda';
import {isNotNilOrEmpty, isTruthy} from 'ramda-adjunct';

import {Brand, ButtonStyled, Icon} from './utils/styles';
import {ButtonProps} from './utils/types';

/**
 * @deprecated - use platform instead
 */
const ButtonWithRef: ForwardRefRenderFunction<HTMLButtonElement, ButtonProps> = (
  {icon, iconRight, children, brand, href, disabled, onClick, ...rest},
  ref
) => {
  const onlyIcon = isNotNilOrEmpty(icon) && isNil(children);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    onClick?.(event);
  };

  const DatButton = (
    <ButtonStyled
      {...rest}
      ref={ref}
      onlyIcon={onlyIcon}
      disabled={disabled}
      normal={onlyIcon && !rest.compact}
      as={href ? 'a' : 'button'}
      onClick={handleClick}
      data-testid={rest['data-testid']}
    >
      <Show when={isTruthy(icon) && !iconRight}>
        <Icon data-testid="button-icon" onlyIcon={onlyIcon}>
          {icon}
        </Icon>
      </Show>
      {children}
      <Show when={isTruthy(icon) && iconRight}>
        <Icon data-testid="button-icon" iconRight onlyIcon={onlyIcon}>
          {icon}
        </Icon>
      </Show>
      <Show when={isTruthy(brand)}>
        <Brand>{brand}</Brand>
      </Show>
    </ButtonStyled>
  );

  return href ? (
    <Link to={href} data-testid={rest['data-testid']}>
      {DatButton}
    </Link>
  ) : (
    DatButton
  );
};

export const Button = forwardRef(ButtonWithRef);
